//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
import {
    Table,
} from 'reactstrap';
import config from '../../config';

//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import ViewPopup from "../Common/Popup/ViewPopup";
import { userActions } from "../../_actions";
import { shopActions, orderActions } from "../../_actions";
import CurrentOrderList from './CurrentOrderList';


class CurrentOrders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            getCouponList: [],
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            advertisments: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
            shopKeeperAdd: false,
            shopKeeperData: []
        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;

        dispatch(shopActions.getAllShopKeeper(apiConstants.GET_SHOP_AND_SHOPKEEPER, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        if (props.getShopAndShopkeeperList) {
            const receivedShopData = props.getShopAndShopkeeperList.getShopAndShopkeeperList
            if (receivedShopData.data !== undefined && receivedShopData.pagination !== undefined) {
                this.setState({
                    shopKeeperData: receivedShopData,
                    totalPage: receivedShopData.pagination.totalPages,
                    totalDataCount: receivedShopData.pagination.totalCount,
                })
            }
        }
    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;

        dispatch(shopActions.getAllShopKeeper(apiConstants.GET_SHOP_AND_SHOPKEEPER, postData));
    }


    changeTableData = (e) => {
        const { dispatch } = this.props;

        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = parseInt(e.target.value);

        dispatch(shopActions.getAllShopKeeper(apiConstants.GET_SHOP_AND_SHOPKEEPER, postData));
    }
    /*
    * searchOrders - User can search data from the database and it will appear
    */
    searchOrders(keyword, perpage, pageNo) {
      const { dispatch } = this.props;
      let userData = JSON.parse(sessionStorage.getItem('user'));

      let postData = {};
      postData.page = pageNo;
      postData.orderBy = "id";
      postData.orderByAscDesc = "ASC";
      postData.perPage = perpage;
      if(userData.role_type[0] == 'shopkeeper'){ postData.shopkeeperId = userData._id; }

      dispatch(orderActions.getAllOrders(apiConstants.GET_ALL_ORDERS, postData));


        if (keyword.target.value !== '') {
            postData.search = keyword.target.value;
            dispatch(orderActions.getAllOrders(apiConstants.SEARCH_ORDER, postData));
        } else {
            dispatch(orderActions.getAllOrders(apiConstants.GET_ALL_ORDERS, postData));
        }
    }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    popupOpen = (advertisments, type, btnClick) => {
        //-- check add button clicked
        if (btnClick === 'addButton') {
            this.setState({ addButton: true });
            this.setState({ popupType: 'AddShopkeeper' })
        }
        //this.setState({ advertisments, [type]: true })
    };


    /*
    *   Close the popup
    */
    popupClose = (type) => {
        this.setState({
            advertisments: {
                title: '',
                type: '',
                advertisment_image: '',
            },
            addButton: false,
            [type]: false
        });
    };

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const { history } = this.props;
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.LABEL_CURRENT_ORDER}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800 fontBold">{siteConstants.LABEL_CURRENT_ORDER}</h1>
                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        {/*<input type="search" placeholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" aria-controls="dataTable" onChange={(e) => this.searchOrders(e, this.state.perPage, 1)} />*/}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <Table hover responsive className="table-outline mb-0 d-none d-sm-table">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th className="text-center"><i className="icon-people"></i></th>
                                                    <th>User</th>
                                                    <th className="text-center">Order #</th>
                                                    <th>Items</th>
                                                    <th className="text-center">Payment</th>
                                                    <th>Date/Time</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-center">
                                                        <div className="avatar">
                                                            <img src={'assets/img/avatars/1.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com" />
                                                            <span className="avatar-status badge-success"></span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>Nilesh Gupta</div>
                                                        <div className="small text-muted">
                                                            Neev Indore
                                                            </div>
                                                        <div>992687</div>
                                                    </td>
                                                    <td className="text-center">
                                                        <i className="flag-icon flag-icon-us h4 mb-0" title="us" id="us"></i>
                                                    </td>
                                                    <td>
                                                        <div className="clearfix">
                                                            Tshirt -2
                                                            </div>
                                                    </td>
                                                    <td className="text-center">
                                                        Paid
                                                        </td>
                                                    <td>
                                                        <div className="small text-muted">Last login</div>
                                                        <strong>10 sec ago</strong>
                                                    </td>
                                                    <td>Pick</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-center">
                                                        <div className="avatar">
                                                            <img src={'assets/img/avatars/1.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com" />
                                                            <span className="avatar-status badge-success"></span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>Nilesh Gupta</div>
                                                        <div className="small text-muted">
                                                            Neev Indore
                                                            </div>
                                                        <div>992687</div>
                                                    </td>
                                                    <td className="text-center">
                                                        <i className="flag-icon flag-icon-us h4 mb-0" title="us" id="us"></i>
                                                    </td>
                                                    <td>
                                                        <div className="clearfix">
                                                            Tshirt -2
                                                            </div>
                                                    </td>
                                                    <td className="text-center">
                                                        Paid
                                                        </td>
                                                    <td>
                                                        <div className="small text-muted">Last login</div>
                                                        <strong>10 sec ago</strong>
                                                    </td>
                                                    <td>Pick</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-center">
                                                        <div className="avatar">
                                                            <img src={'assets/img/avatars/1.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com" />
                                                            <span className="avatar-status badge-success"></span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>Nilesh Gupta</div>
                                                        <div className="small text-muted">
                                                            Neev Indore
                                                            </div>
                                                        <div>992687</div>
                                                    </td>
                                                    <td className="text-center">
                                                        <i className="flag-icon flag-icon-us h4 mb-0" title="us" id="us"></i>
                                                    </td>
                                                    <td>
                                                        <div className="clearfix">
                                                            Tshirt -2
                                                            </div>
                                                    </td>
                                                    <td className="text-center">
                                                        Paid
                                                        </td>
                                                    <td>
                                                        <div className="small text-muted">Last login</div>
                                                        <strong>10 sec ago</strong>
                                                    </td>
                                                    <td>Pick</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-center">
                                                        <div className="avatar">
                                                            <img src={'assets/img/avatars/1.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com" />
                                                            <span className="avatar-status badge-success"></span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>Nilesh Gupta</div>
                                                        <div className="small text-muted">
                                                            Neev Indore
                                                            </div>
                                                        <div>992687</div>
                                                    </td>
                                                    <td className="text-center">
                                                        <i className="flag-icon flag-icon-us h4 mb-0" title="us" id="us"></i>
                                                    </td>
                                                    <td>
                                                        <div className="clearfix">
                                                            Tshirt -2
                                                            </div>
                                                    </td>
                                                    <td className="text-center">
                                                        Paid
                                                        </td>
                                                    <td>
                                                        <div className="small text-muted">Last login</div>
                                                        <strong>10 sec ago</strong>
                                                    </td>
                                                    <td>Pick</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-center">
                                                        <div className="avatar">
                                                            <img src={'assets/img/avatars/1.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com" />
                                                            <span className="avatar-status badge-success"></span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>Nilesh Gupta</div>
                                                        <div className="small text-muted">
                                                            Neev Indore
                                                            </div>
                                                        <div>992687</div>
                                                    </td>
                                                    <td className="text-center">
                                                        <i className="flag-icon flag-icon-us h4 mb-0" title="us" id="us"></i>
                                                    </td>
                                                    <td>
                                                        <div className="clearfix">
                                                            Tshirt -2
                                                            </div>
                                                    </td>
                                                    <td className="text-center">
                                                        Paid
                                                        </td>
                                                    <td>
                                                        <div className="small text-muted">Last login</div>
                                                        <strong>10 sec ago</strong>
                                                    </td>
                                                    <td>Pick</td>
                                                </tr>
                                            </tbody>
                                        </Table> */}

                                        <CurrentOrderList history={history}/>

                                    </div>
                                    {/* calling the another componenet */}
                                    {/*<Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />*/}

                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    <Footer />
                </div>

                {/* Start Popup -View advertisments details  */}
                <ViewPopup
                    popupType="AdvertismentsComponenet"
                    viewOpen={this.state.viewOpen}
                    advertisments={this.state.advertisments}
                    funPopupClose={this.popupClose}
                />
                {/* End Popup -View advertisments details  */}

            </div >
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getCoupounList, language, getShopAndShopkeeperList } = state;
    return {
        getCoupounList,
        language,
        getShopAndShopkeeperList
    };
}

const connectedCurrentOrders = connect(mapStateToProps)(CurrentOrders);
export { connectedCurrentOrders as CurrentOrders };
